import { Children, ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface Props {
  children: ReactNode;
  max?: number;
  total?: number;
  className?: string;
  overflowNode?: (count: number) => ReactNode;
}

const AvatarGroup = ({ children, max = 3, total, className, overflowNode }: Props) => {
  const childArray = Children.toArray(children);
  const displayedChildren = childArray.slice(0, max);
  const overflowCount = (total ?? childArray.length) - displayedChildren.length;

  return (
    <div className={cn('flex flex-row-reverse items-center -space-x-1 space-x-reverse', className)}>
      {overflowCount > 0 &&
        (overflowNode ? (
          overflowNode(overflowCount)
        ) : (
          <span className="z-10 flex size-4 items-center justify-center rounded-full border-2 border-background bg-bg-muted text-[10px] text-foreground-muted">
            +{overflowCount}
          </span>
        ))}
      {displayedChildren}
    </div>
  );
};

export default AvatarGroup;
